/** Сохраняет показанные строки и обновляет временные URL уже известных событий. */
export function mergeCategoryLogs<T extends { id: string | number; timestamp: string }>(previous: T[], incoming: T[], limit: number): T[] {
  const rows = new Map(incoming.map(row => [String(row.id), row]));
  previous.forEach(row => { if (!rows.has(String(row.id))) rows.set(String(row.id), row); });
  return Array.from(rows.values()).sort((a, b) => b.timestamp.localeCompare(a.timestamp)).slice(0, limit);
}
